import { Box, Button, Chip, Typography } from "@mui/material";
import { Outlet, useParams, useLocation } from "react-router-dom";
import { PageHeader } from "../../components/PageHeader";
import { NavTab } from "../../components/Tabs/NavTabs.container";
import { RoutePath } from "../../defines/route-path";
import { ArrowBackIos, EditOutlined, Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { NewRequestModal } from "./newRequestModal.container";
import { useRequestsContext } from "../../contexts/requests/RequestsContext";
import { useRequestsActions } from "../../contexts/requests/UseRequestsActions";
import { useAuthContext } from "../../contexts/authentication/AuthenticationContext";
import { Role } from "../../core/models/User";
import IntlMessages from "../../components/IntlMessages/IntlMessages";

const RequestsDetailsInvitations = () => {
  const { id } = useParams<{ id: string }>();
  const { userInfo } = useAuthContext();
  const isBusinessUser = userInfo?.permissionRole === Role.Business;
  const tabs: Array<NavTab> = isBusinessUser
    ? [
        {
          label: "invitations.data",
          href: RoutePath.INVITATIONS.replace(":id", id ?? ""),
        },
      ]
    : [
        {
          label: "request.details",
          href: RoutePath.STEPS.replace(":id", id ?? ""),
        },
        {
          label: "invitations.data",
          href: RoutePath.INVITATIONS.replace(":id", id ?? ""),
        },
      ];

  const {
    selectedRequest,
    setSelectedRequest,
    saveRequestDetailsTrigger,
    setSaveRequestDetailsTrigger,
  } = useRequestsContext();
  const { dispatchGetRequest } = useRequestsActions();

  const navigate = useNavigate();
  const location = useLocation();
  const [openNewRequestModal, setOpenNewRequestModal] =
    useState<boolean>(false);

  //#region Page actions
  const onCancel = () => navigate(-1);
  const onSave = () => {
    setSaveRequestDetailsTrigger(-1); // Save button is clicked
  };

  const isStepsPage = location.pathname.includes("steps");
  const toggleOpenNewRequestModal = () => {
    setOpenNewRequestModal(!openNewRequestModal);
  };
  //#endregion
  //#region Fetch request if not in context
  useEffect(() => {
    if (!selectedRequest && id) {
      dispatchGetRequest(id);
    }
  }, [id, selectedRequest, setSelectedRequest]);
  //#endregion
  const onBack = () => {
    navigate(RoutePath.REQUESTS);
  };
  return (
    <Box
      id="pageWrapper"
      className="w-full flex flex-col flex-1 space-y-[1.875rem]"
    >
      <Button
        className="w-full flex space-x-[0.5rem] justify-start"
        variant="text"
        onClick={onBack}
        data-testid="backButton"
      >
        <ArrowBackIos color="primary" />
        <Typography color="primary" variant="body1" fontWeight={600}>
          <IntlMessages id="request.back.title" />
        </Typography>
      </Button>
      <PageHeader
        tabs={tabs}
        title={selectedRequest?.title}
        moreAction={
          !isBusinessUser
            ? {
                icon: <EditOutlined />,
                onClick: () => setOpenNewRequestModal(true),
              }
            : undefined
        }
        {...(isStepsPage && {
          onCancel: onCancel,
          onSave: onSave,
        })}
        disableSave={saveRequestDetailsTrigger === 0}
      />
      <Box className="h-full">
        <Outlet />
      </Box>
      {openNewRequestModal && (
        <NewRequestModal
          open={openNewRequestModal}
          id={id}
          data-testid="newRequestModal"
          onClose={() => toggleOpenNewRequestModal()}
        />
      )}
    </Box>
  );
};

export { RequestsDetailsInvitations };
